import { IComplaint } from "../complaints/complaints";
import { IAdministrativeComplaintView, ICorrespondenceView, INotesView } from "../mainMenu/mainMenu";
import { IEnclosedAreaEditHistory } from "../reports/reports";
import { ISiteVisitConductedLkp } from "../shared/shared";

export interface IBusiness{
  businessId: number;
  busCatId: number;
  parentId: number;
  active: number;
  parentContact: number;
  inViolation: number;
  countyId: string;
  ctateId: string;
  businessName: string;
  businessOwner: string;
  businessOwnerTitle: string;
  businessOwnerPhone: string;
  businessOwnerEmail: string;
  businessAddress1: string;
  businessAddress2: string;
  businessCity: string;
  businessZip: string;
  businessZipExt: string;
  businessPhone: string;
  businessPhoneExt: string;
  contactName: string;
  contactTitle: string;
  contactEmail: string;
  notes: string;
  bexempt: boolean;
  exemptStatus: number;
  exemptType: number;
  exemptApprovedBy: string;
  exemptCertificationDate: Date;
  exemptSmokingAllowed: boolean;
  exemptEnteredBy: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  
  parent: IParentBusiness;

  businessCitation: IBusinessCitation;
  businessCorrespondence: IBusinessCorrespondence;
  businessEnclosedArea: IBusinessEnclosedArea;
  businessFollowUpSiteVisit: IBusinessFollowUpSiteVisit;
  businessInitialSiteVisit: IBusinessInitialUpSiteVisit;
  businessNotes: IBusinessNotes;
  businessRemediationPlanSiteVisit: IBusinessRemediationPlanSiteVisit;
  complaint: IComplaint;
}

export interface IParentBusiness{ 
  parentId: number;
  firstName: string;
  lastName: string;
  contactTitle: string;
  contactEmail: string;
  contactPhone: string;
  contactPhoneExt: string;
  businessName: string;
  businessAddress1: string;
  businessAddress2: string;
  businessCity: string;
  businessZip: string;
  businessZipExt: string;
  stateId: string;
  businessPhone: string;
  businessPhoneExt: string;

  business: IBusiness;
}

export interface IBusinessEnclosedArea{
  enclosedAreaId: number;
  businessId: number;
  timeStamp: Date;
  isEnclosedArea: boolean;
  enclosedAreaReviewed: boolean;
  enclosedAreaDetermination: Date;
  enclosedAreaDeterminationComments: string;
  loggedUser: string;
  complaintId: number;
  visitDate: Date;
  comments: string;

  business: IBusiness;
  complaint: IComplaint;
  businessEnclosedAreaHistory: IBusinessEnclosedAreaHistory;
  businessEnclosedAreaUploads: IBusinessEnclosedAreaUploads;
}

export interface IBusinessEnclosedAreaHistory{
  enclosedAreaHistoryId: number;
  enclosedAreaId: number;
  timeStamp: Date;
  isEnclosedArea: boolean;
  enclosedAreaReviewed: boolean;
  enclosedAreaDetermination: Date;
  enclosedAreaDeterminationComments: string;
  loggedUser: string;
  complaintId: number;
  visitDate: Date;
  comments: string;

  enclosedArea: IBusinessEnclosedArea;
}

export interface IBusinessEnclosedAreaUploads{
  enclosedAreaUploadId: number;
  enclosedAreaId: number;
  contentType: string;
  extension: string;
  uploadFile: Blob;
  name: string;
  description: string;
  dateTime: Date;
  staffName: string;

  enclosedArea: IBusinessEnclosedArea;
}

export interface IUsers{
  userId: string;
  countyId: string;
  username: string;
  supervisorName: string;
  supervisorEmail: string;
  email: string;
  firstName: string;
  lastName: number;
  enabled: number;
  accountExpired: number;
  accountLocked: number;
  credentialsExpired: string;
  password: string;
}

export interface IBusinessCitation{
  businessCitationId: number;
  businessId: number;
  complaintId: number;
  countyCopyDate: Date;
  citationIssuedDate: Date;
  fineReceivedDate: Date;
  dhsReviewDate: Date;
  dojReviewDate: Date;
  notIssuedReason: string;
  visitDate: Date;
  notes: string;
  finalOrderDate: Date;
  penaltyAmt: string;
  settleAgree: string;
  finalOrderReason: string;
  saAmt: string;
  saAbeyance: string;
  saSigned: Date;
  saUntil: Date;
  saPaid: Date;
  citationWarranted: boolean;
  hearingRequested: boolean;
  finalOrderIssued: boolean;
  settlementAgreement: boolean;
  hearingDate: Date;
  hearingReason: string;
  saRequiredAmount: string;
  civilPenalty: boolean;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  businessFollowUpSiteVisitId: number;
  annualInspectionStatus: number;

  business: IBusiness;
  complaint: IComplaint;
}

// export interface IBusinessCitation{
//   businessCitationId: number;
//   businessId: number;
//   complaintId: number;
//   countyCopyDate: Date;
//   citationIssuedDate: Date;
//   fineReceivedDate: Date;
//   dhsReviewDate: Date;
//   dojReviewDate: Date;
//   notIssuedReason: string;
//   visitDate: Date;
//   notes: string;
//   finalOrderDate: Date;
//   pPenaltyAmt: string;
//   settleAgree: string;
//   finalOrderReason: string;
//   saAmt: string;
//   saAbeyance: string;
//   saSigned: Date;
//   saUntil: Date;
//   saPaid: Date;
//   citationWarranted: boolean;
//   hearingRequested: boolean;
//   finalOrderIssued: boolean;
//   settlementAgreement: boolean;
//   hearingDate: Date;
//   hearingReason: string;
//   saRequiredAmount: string;
//   civilPenalty: boolean;
//   lastUpdatedBy: string;
//   DlastUpdatedDate: Date;
//   businessFollowUpSiteVisitId: number;
//   annualInspectionStatus: number;

//   business: IBusiness;
//   complaint: IComplaint;
// }

export interface IBusinessCorrespondence{
  corrId: number;
  businessId: number;
  complaintId: number;
  corrTypeId: number;
  generatedDate: Date;
  sentDate: Date;
  hardCopyDate: Date;
  letterText: string;
  notes: string;
  title: string;
  discardedCorrespondence: number;
  contentType: string;
  extension: string;
  uploadFile: Blob;
  uploadDateTime: Date;
  uploadedBy: string;
  invalidAddress: boolean;

  usiness: IBusiness;
  complaint: IComplaint;
  // virtual CorrTypeLkp CorrType { get; set; }
}

export interface IBusinessInitialUpSiteVisit{
  businessInitialSiteVisitId: number;
  businessId: number;
  origComplaintDate: Date;
  subsequentComplaintDate: Date;
  visitDate: Date;
  notes: string;
  visitConducted: number;
  violationFound: number;
  visitConductedReason: number;
  complaintId: number;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;

  business: IBusiness;
  complaint: IComplaint;
  visitConductedReasonNavigation: ISiteVisitConductedLkp;
}

export interface IBusinessFollowUpSiteVisit{
  businessFollowUpSiteVisitId: number;
  businessId: number;
  visitDate: Date;
  reqImplementationDate: Date;
  actualCompletionDate: Date;
  viloationNotes: string;
  correctionRequiredNotes: string;
  remedResult: string;
  followUpDate: Date;
  followUpConducted: number;
  followUpDateConducted: number;
  followUpIsInspection: number;
  comments: string;
  complaintId: number;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  followUpInspectionType: number;
  visitConductedReason: number;
  inspectionParentId: number;

  business: IBusiness;
  complaint: IComplaint;
  visitConductedReasonNavigation: ISiteVisitConductedLkp;
  businessRemediationPlanSiteVisit: IBusinessRemediationPlanSiteVisit;
}

export interface IBusinessInitialSiteVisit{
  businessInitialSiteVisitId: number;
  businessId: number;
  origComplaintDate: Date;
  subsequentComplaintDate: Date;
  visitDate: Date;
  notes: string;
  visitConducted: number;
  violationFound: number;
  visitConductedReason: number;
  complaintId: number;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;

  business: IBusiness;
  complaint: IComplaint;
  visitConductedReasonNavigation: ISiteVisitConductedLkp;
}

export interface IBusinessNotes{
  notesId: number;
  businessId: number;
  timeStamp: Date;
  noteType: string;
  notes: string;
  loggedUser: string;
  business: IBusiness;
}

export interface INotesViewModel {
  id: number;
  loggedDate: string;
  type: string;
  text: string;
  user: string;
}

export interface IBusinessRemediationPlanSiteVisit{
  businessRemediationPlanSiteVisitId: number;
  businessId: number;
  businessFollowUpSiteVisitId: number;
  postRemediationConducted: number;
  postRemediationVisitDate: Date;
  postRemediationResult: string;
  comments: string;
  complaintId: number;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;

  business: IBusiness;
  businessFollowUpSiteVisit: IBusinessFollowUpSiteVisit;
  complaint: IComplaint;
}

export interface IBusinessView{
  id: number;
  businessType: number;
  exempt: boolean;
  exemptCertificateDate: string;
  exemptTypeId: number;
  exemptType: string;
  exemptStatusId: number;
  exemptStatus: string;
  canInspect: boolean;
  exemptApprovedBy: string;
  exemptEnteredBy: string;
  exemptSmokingAllowed: boolean;
  category: string;
  active: boolean;
  inViolation: boolean;
  countyId: string;
  countyName: string;
  stateId: string;
  businessName: string;
  businessOwner: string;
  businessOwnerTitle: string;
  businessOwnerPhone: string;
  businessOwnerEmail: string;
  businessAddress1: string;
  businessAddress2: string;
  businessCity: string;
  businessZip: string;
  businessZipExt: string;
  businessPhone: string;
  businessPhoneExt: string;
  contactName: string;
  contactTitle: string;
  contactEmail: string;
  notes: string;
  complaintId: number;
  associatedBusinessId: string;
  parentBusinessId: number;
  parentBusinessName: string;
  parentBusinessContactFirstName: string;
  parentBusinessContactLastName: string;
  parentBusinessContactTitle: string;
  parentBusinessAddress: string;
  parentBusinessAddress2: string;
  parentBusinessCity: string;
  parentBusinessState: string;
  parentBusinessZip: string;
  parentBusinessZipExt: string;
  parentBusinessPhone: string;
  parentBusinessPhoneExt: string;
  parentBusinessEmail: string;
  useParentBusinessContact: boolean;
  totalComplaints: number;
  complaints: IAdministrativeComplaintView[];
  comments: INotesView[];
  businessCorrespondence: ICorrespondenceView;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
}

export interface IBusinessEnclosedAreasViewModel{
  enclosedAreaHistory: IEnclosedAreaEditHistory[];
  currentEnclosedArea: IEnclosedAreaEditHistory;
}

